import React, { useEffect, useState } from 'react'
import Card from '../../../../common/card/Card'
import { useParams } from 'react-router-dom'
import { QueryClient, useQuery } from '@tanstack/react-query'
import { performRequest } from '../../../../common/utils'
import Loader from '../../../../common/loader/Loader'
// import MembersTable from './MembersTable'
import useLicenseTable from '../context/LicenseTableContext'
import ExpiringLicensesTable from './ExpiringLicenseTable.tsx'


const ExpiringLicenses = ({teamType, membersSelection}) => {

  const params = useParams()
  const teamId = params.team_id
  const [ responseMessage, setResponseMessage ] = useState('')
  const { setRefetchLicenses, setSelectedLicense, setSelectedModal, setSelectedBulkLicense } = useLicenseTable()

  const queryClient = new QueryClient()

  const {
    isLoading,
    isPending,
    isFetching,
    isError,
    error,
    refetch,
    data } = useQuery({
      queryKey: ['get_org_expired_licenses'],
      queryFn: requestOrgLicenses,
      refetchOnWindowFocus: false
    }, queryClient)

  async function requestOrgLicenses() {
    const {
      group_dashboard: { nonce, base }
    } = window
    let url = base + 'membersync/licensing/v1/org/' + teamId + '/licenses'

    const res = await fetch(`${url}`, {
      method: 'POST',
      body: JSON.stringify({
        expired: true,
        exclude_dismissed: true
      }),
      headers: {
        'X-WP-Nonce': nonce,
        'Content-type': "application/json"
      },
      credentials: 'same-origin',
      processData: false,
      contentType: false,
    })

    if ( !res.ok ) throw Error(res.statusText)

    const resultJSON = await res.json()
    return resultJSON.response
  }

  // console.log('data : ', data)

  useEffect(() => {
    setRefetchLicenses(() => refetch)
    setSelectedLicense('')
    setSelectedModal('')
    setSelectedBulkLicense('')
  }, [ refetch ])

  if( isLoading || isPending || isFetching ){
    return (
      <Loader type='spinner-dual-ring'/>
    )
  }

  if( isError ){
    return (
      <Card> 
        <strong> { error.message } </strong> 
      </Card>
    )
  }

  return (
    <>
      {
        responseMessage && responseMessage !== ''
        ? <Card> 
            <strong>{ responseMessage }</strong> 
          </Card>
        : data.licenses && (data.licenses).length !== 0 && <ExpiringLicensesTable licensesData={ data } membersSelection={ membersSelection } />
      }
    </>
  )
}

export default ExpiringLicenses
